import apiService from "./apiService";

const logService = {
    async getLogs(page, searchModel) {
        try {
            return (await apiService.get(`s/search-system-logs/${page}`, searchModel, true)).data;
        }
        catch {
            return {currentPage: 1,totalItems: 0, totalPages: 1, logs: []};
        }
    },

    async getScannerLogs(page, searchModel) {
        try {
            return (await apiService.get(`v/search-scanner-logs/${page}`, searchModel, true)).data;
        }
        catch {
            return {currentPage: 1,totalItems: 0, totalPages: 1, logs: []};
        }
    }

};

export default logService;